<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--up" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="m5 16 7.5-8 7.5 8" stroke="currentColor"/></svg></template>